import { registerServiceProvider } from '@timing71/common';

import { ALMS, ELMS, LeMansCup, LM24, WEC } from "./aco/index.js";
import { AlKamel } from "./alkamel/index.js";
import { Cronococa } from './cronococa/index.js';
import { F1Academy, F2, F3 } from "./feederSeries/index.js";
import { FIAWEC } from './fiawec_tv/index.js';
import { IndyCar } from "./indycar/index.js";
import { ITSLive } from './itslive/index.js';
import { MotoGP } from './motogp/service.js';
import { Nascar } from "./nascar/index.js";
import { Natsoft } from "./natsoft/index.js";
import { SoftPauer } from "./softpauer/index.js";
import { SwissTiming } from "./swissTiming/index.js";
import { TimeService } from "./timeservice/index.js";
import { TSL } from './tsl/index.js';
import { TSLLegacy } from "./tslLegacy/index.js";
import { Wige } from './wige/service.js';
import { WSeries } from "./wseries/index.js";
import { IMSA } from './imsa/service.js';

const PROVIDERS = [
  IMSA, // TODO properly implement provider priorities to make sure this always
        // takes precedence over the AlKamel parent service - for now, list it
        // first
  AlKamel,
  ALMS,
  Cronococa,
  ELMS,
  F1Academy,
  F2,
  F3,
  FIAWEC,
  IndyCar,
  ITSLive,
  LeMansCup,
  LM24,
  MotoGP,
  Nascar,
  Natsoft,
  SoftPauer,
  SwissTiming,
  TimeService,
  TSL,
  TSLLegacy,
  Wige,
  WEC,
  WSeries
];

PROVIDERS.forEach(
  p => registerServiceProvider(p)
);
